import {
  REACT_APP_API_BASE_URL,
  REACT_APP_COGNITO_REGION,
  REACT_APP_COGNITO_USER_POOL_CLIENT_ID,
  REACT_APP_COGNITO_USER_POOL_ID,
} from '../configs';
import axios from 'axios';
import { APIApi } from './server';
import { attachAuthInterceptor } from './authInterceptor';
import { Amplify, Auth } from 'aws-amplify';
import { CognitoUser } from 'amazon-cognito-identity-js';

export const getToken = async () => {
  let token = '';
  try {
    const user = (await Auth.currentAuthenticatedUser()) as CognitoUser;
    token = user.getSignInUserSession()?.getIdToken().getJwtToken() ?? '';
  } catch (error) {
    console.log("getToken error: ", error)
  }
  return token;
};
export const serverApi = (() => {
  // FIXME Amplifyの設定を別ファイルにまとめたい。（Repositoryパターンのように使う側がAmplifyを意識しない形に。）
  Amplify.configure({
    region: REACT_APP_COGNITO_REGION,
    userPoolId: REACT_APP_COGNITO_USER_POOL_ID,
    userPoolWebClientId: REACT_APP_COGNITO_USER_POOL_CLIENT_ID,
  });
  // 認証(Authorization ヘッダー)は axios のインターセプターで付与する。生成コードには手を入れない
  const axiosInstance = axios.create();
  attachAuthInterceptor(axiosInstance, getToken);
  return new APIApi(
    {
      isJsonMime: (mime: string): boolean => {
        const jsonMime: RegExp = new RegExp(
          `^(application/json|[^;/ \t]+/[^;/ \t]+[+]json)[ \t]*(;.*)?$', 'i'`,
        );
        return (
          mime !== null &&
          (jsonMime.test(mime) || mime.toLowerCase() === 'application/json-patch+json')
        );
      },
      basePath: REACT_APP_API_BASE_URL,
    },
    undefined,
    axiosInstance,
  );
})();

// 追加関数
/**
 * API 呼び出しのラッパー。
 * Authorization ヘッダーは axios のインターセプター(attachAuthInterceptor)で付与するため、
 * ここではコールバックを実行するだけ。既存の呼び出し側との互換のために残している。
 */
export const requestServerApi = async <T>(callback: () => T) => {
  return await callback();
};
